import React from 'react';
import { BRAND, isMarketGB } from '../../constants/main';
import { ToggleStyledAC } from './AC/ToggleStyled.AC';
import { ToggleStyledAP } from './AP/ToggleStyled.AP';
import { ToggleStyledDS } from './DS/ToggleStyled.DS';
import { ToggleStyledOV } from './OV/ToggleStyled.OV';
import { ToggleStyledOV as ToggleStyledOV_GB } from './OV/GB/ToggleStyled.OV';
import { ToggleStyled } from './ToggleStyled';
import { SC } from '../../styles/theme';

export interface ToggleProps extends SC {
    optionA: string;
    optionB: string;
    toggled?: boolean;
    disabled?: boolean;
    id?: string;
    page?: string;
    onClick?: (option: string) => void;
    isHorizontal?: boolean;
    isCondensed?: boolean;
}

const Toggle = (props: ToggleProps) => {
    if (BRAND === 'AC') return <ToggleStyledAC {...props} />;
    if (BRAND === 'OV') return isMarketGB ? <ToggleStyledOV_GB {...props} /> : <ToggleStyledOV {...props} />;
    if (BRAND === 'AP') return <ToggleStyledAP {...props} />;
    if (BRAND === 'DS') return <ToggleStyledDS {...props} />;
    return <ToggleStyled {...props} />;
};

export default Toggle;
